export default __webpack_public_path__ + "static/media/sowmz-window-crop.c4b132f5.jpg";